import React from 'react';
import {createRoot} from 'react-dom/client';
import {useSHCore} from '@hooks/useSHCore';
import {getInitialMeta, getInitialPageState} from "@helpers/HelperInitialPageState";
//import styles from './Page404.scss';
import Header from '@components/base/Header/Header';
import Footer from '@components/base/Footer/Footer';
import CommonPageHeader404 from '@components/base/Header/data/CommonPageHeader404';
import MenuBottom from "@components/base/MenuBottom/MenuBottom";

const Page404 = (props) => {
	useSHCore({props, name: 'Page404', isPage: true});

	return (
	  <>
		  <Header data={CommonPageHeader404}/>
		  <Footer color={'color-brand-orange-400'} noMarginTop={true}/>
		  <MenuBottom color={'color-brand-orange-400'}/>
	  </>
	)
};

const container = document.getElementById(getInitialMeta('pageAppId'));
const root = createRoot(container);
root.render(<Page404 data={getInitialPageState()}/>);
